import 'swiper/css';
import {ReactNode} from 'react';
import styled from 'styled-components';
import {Swiper as SwiperContainer, SwiperProps, SwiperSlide as SwiperSlideReal} from 'swiper/react';
import {interceptProps} from '@/styled-components';
import {LAYOUT_Z_INDEX} from '@/styles';

interface IProps extends SwiperProps {
  children: ReactNode;
  hidden?: boolean;
}

export const Swiper = ({hidden, children, ...swiperProps}: IProps) => {
  return (
    <Root hidden={hidden}>
      <SwiperContainer slidesPerView="auto" centeredSlides={true} spaceBetween={6} {...swiperProps}>
        {children}
      </SwiperContainer>
    </Root>
  );
};

// 명시적 사용으로 tree-shaking 방지
export const SwiperSlide = SwiperSlideReal;

const Root = styled('div').withConfig({
  shouldForwardProp: interceptProps(['hidden']),
})<{
  hidden?: boolean;
}>`
  position: absolute;
  left: 0;
  bottom: 18px;
  z-index: ${LAYOUT_Z_INDEX.NAVBAR};
  width: 100%;
  .swiper-slide {
    width: calc(100% - 32px);
  }
  ${({hidden}) => hidden && `visibility: hidden;`}
`;
